import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import LookedForSection from "@/components/VulnerabilityWatch/Portal/LookedForSection.tsx";
import NamedLaterSection from "@/components/VulnerabilityWatch/Portal/NamedLaterSection.tsx";
import PortalFigures from "@/components/VulnerabilityWatch/Portal/PortalFigures.tsx";
import TrafficSection from "@/components/VulnerabilityWatch/Portal/TrafficSection.tsx";
import WhoTheyAreSection from "@/components/VulnerabilityWatch/Portal/WhoTheyAreSection.tsx";
import { usePortalOverview } from "@/hooks/useVulnerabilityWatch.ts";
import { knownOverview } from "@/utils/portalOverview.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function PortalTab() {
  const { data, isLoading, error } = usePortalOverview();
  if (isLoading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}><CircularProgress /></Box>;
  if (error) return <Alert severity="error">{copy.PORTAL_LOAD_FAILED}</Alert>;
  const overview = knownOverview(data);
  return (
    <Stack spacing={3}>
      <PortalFigures overview={overview} />
      <TrafficSection overview={overview} />
      <LookedForSection overview={overview} />
      <WhoTheyAreSection overview={overview} />
      <NamedLaterSection overview={overview} />
    </Stack>
  );
}
